export default {
    'show-invoice': "عرض الفاتورة",
    'show-order': "عرض الطلبية",
    'invoice-updated-successfully': 'تم تحديث بيانات الفاتورة'
}